module.exports = __webpack_public_path__ + "img/微信图片_20251001102859_1952_207.8beb9b5e.jpg";